export var getMenu = function getMenu(urlMenuService, menuSection) {
  var url = "".concat(urlMenuService, "/Menu/GetMenuHeader?section=").concat(menuSection);
  return fetch(url).then(function (response) {
    return response.json();
  }).then(function (data) {
    return data;
  });
};